declare global {
  interface Window {
    webkitAudioContext?: typeof AudioContext;
    __suspendAllAudio?: () => Promise<void>;
    __resumeAllAudio?: () => Promise<void>;
  }
}

const audioContexts: AudioContext[] = [];

function track(ctx: AudioContext) {
  audioContexts.push(ctx);
}

export function installAudioContextHooks(): void {
  if (typeof window.AudioContext !== 'undefined') {
    const OriginalAC = window.AudioContext;
    const WrappedAC = class extends OriginalAC {
      constructor(contextOptions?: AudioContextOptions) {
        super(contextOptions);
        track(this);
      }
    };
    window.AudioContext = WrappedAC as unknown as typeof OriginalAC;
  }

  if (typeof window.webkitAudioContext !== 'undefined') {
    const OriginalWAC = window.webkitAudioContext;
    const WrappedWAC = class extends OriginalWAC {
      constructor(contextOptions?: AudioContextOptions) {
        super(contextOptions);
        track(this);
      }
    };
    window.webkitAudioContext = WrappedWAC as unknown as typeof OriginalWAC;
  }

  window.__suspendAllAudio = async () => {
    await Promise.all(
      audioContexts.map((ctx) =>
        ctx.state !== 'suspended' ? ctx.suspend() : Promise.resolve(),
      ),
    );
  };

  window.__resumeAllAudio = async () => {
    await Promise.all(
      audioContexts.map((ctx) =>
        ctx.state !== 'running' ? ctx.resume() : Promise.resolve(),
      ),
    );
  };
}

export function registerAudioVisibilityHandlers(): void {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      void window.__suspendAllAudio?.();
    } else {
      void window.__resumeAllAudio?.();
    }
  });
}
